import React, { useState } from 'react';

const SearchBar = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        onSearch(value);
    };

    const inputStyle = {
        backgroundColor: '#eaecec',
        padding: '8px',
        borderRadius: '4px',
        border: 'none',
    };

    return (
        <div className="search-bar text-lg mb-2">
            <input
                type="text"
                placeholder="Buscar..."
                value={searchTerm}
                onChange={handleSearch}
                style={inputStyle}
            />
        </div>
    );
};

export default SearchBar;
